{"switchLanguage":"언어 변경","current":"현재 언어"}